
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Plane } from "lucide-react";

export const NoPackagesFound = () => (
  <Card>
    <CardContent className="text-center py-12">
      <Plane className="w-12 h-12 text-gray-400 mx-auto mb-4" />
      <h3 className="text-lg font-medium text-gray-900 mb-2">لا توجد عروض</h3>
      <p className="text-gray-600 mb-4">لم يتم العثور على عروض تطابق معايير البحث</p>
      <Link to="/create-package">
        <Button>إنشاء أول عرض سياحي</Button>
      </Link>
    </CardContent>
  </Card>
);
